import type { ReactNode } from 'react';

export const symbol_directions: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M380-490h184v49q0 10.5 9.5 14.25T590-430l69-69q9-9.27 9-21.64 0-12.36-9-21.36l-69-69q-7-7-16.5-3.25T564-600v50H350q-12.75 0-21.37 8.62Q320-532.75 320-520v130q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-100Zm99.95 413Q468-77 456.5-81T437-93L93-437q-8-8-12-19.55t-4-23.5q0-11.95 4-23.45T93-523l344-344q8-8 19.55-12t23.5-4q11.95 0 23.45 4t19.5 12l344 344q8 8 12 19.55t4 23.5q0 11.95-4 23.45T867-437L523-93q-8 8-19.55 12t-23.5 4ZM308-308l172 172 344-344-344-344-344 344 172 172Zm172-172Z"
		/>
	</svg>
);
